/** Тело мягкого удаления/восстановления: список id и обязательная причина (10–500 символов). */
export interface DeleteRequest<ID = number | string> {
  ids: ID[];
  reason: string;
}

/** Кто, когда и почему удалил запись; null у живых строк. */
export interface SoftDeleteInfo {
  deletedAt: string;
  deletedBy: string;
  deleteReason: string;
}

export const DELETE_REASON_MIN = 10;
export const DELETE_REASON_MAX = 500;

/** Код отказа: удаление возможно, но сервер ждёт явного подтверждения пользователя. */
export const DELETE_CONFIRMATION_REQUIRED = "DELETE_CONFIRMATION_REQUIRED";
